<template>
	<div>
		<CubePage type="catcheck-view" title="招募合伙人">
			<div slot="content" class="content">
				<div class="divimg-qrcode">
					<van-image v-if="title == 2" width="100%" :src="require('../../../assets/img/share_bg.jpg')">
					</van-image>
					<van-image v-else width="100%" :src="require('../../../assets/img/share_bg1.png')">
					</van-image>
					<div class="qr-img-div">
						<van-image height="100%" width="100%" :src="imgurl">
						</van-image>
					</div>
				</div>
			</div>
		</CubePage>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage
		},
		data() {
			return {
				title: this.$route.query.n,
				imgurl: null
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData() {
				let that = this
				var url = "/addons/litestore/api.store/getQrCode"
				if (that.title == 2) {
					url = "/addons/litestore/api.distributor/getQrCode"
				}
				//这里直接调用网络接口
				util.get(url, {},
					function(result) {
						if (result.data != null) {
							that.imgurl = result.data
						}
					},
				);
			}
		}
	}
</script>

<style lang="less">
	html {
		font-size: 10px;
	}

	.divimg-qrcode {
		position: relative;

		.qr-img-div {
			z-index: 9999;
			position: absolute;
			top: 71.5rem;
			left: 50%;
			width: 19.5rem;
			height: 29rem;
			transform: translateX(-49.5%);
			background-color: aqua;
		}
	}


	@media screen and (width: 320px) {
		html {
			font-size: 8.5px !important;
		}
	}

	@media screen and (width: 360px) {
		html {
			font-size: 9.6px !important;
		}
	}

	@media screen and (min-width: 390px) {
		html {
			font-size: 10.4px !important;
		}
	}
	@media screen and (min-width: 412px)  and (max-width: 414px) {
		html {
			font-size: 11px !important;
		}
	}

	@media screen and (min-width: 540px) {
		html {
			font-size: 14.3px !important;
		}
	}
	@media screen and (min-width: 768px) {
		html {
			font-size: 20.3px !important;
		}
	}
	
	@media screen and (min-width: 820px) {
		html {
			font-size: 21.9px !important;
		}
	}
	@media screen and (min-width: 912px) {
		html {
			font-size: 24.2px !important;
		}
	}
	@media screen and (min-width: 1024px) {
		html {
			font-size: 27.1px !important;
		}
	}
</style>